import React, { createContext, useState } from "react";
import LabOrUser from "../api/models/advanced-search/LabOrUser";
import { setDashboardUserOrLab } from "../helper/UserSettingsHelper";

export interface DashboardContextType {
  labOrUser: LabOrUser;
  updateLabOrUser: (newValue: LabOrUser) => void;
}

export const DashboardContext = createContext<DashboardContextType>({
  labOrUser: null,
  updateLabOrUser: (newValue: LabOrUser) => {},
});

const DashboardContextProvider: React.FunctionComponent = (props) => {
  const [labOrUser, setLabOrUser] = useState<LabOrUser>(null);

  const updateLabOrUser = (newValue: LabOrUser) => {
    setDashboardUserOrLab(newValue);
    setLabOrUser(newValue);
  };

  const { children } = props;

  return (
    <DashboardContext.Provider
      value={{
        labOrUser,
        updateLabOrUser,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardContextProvider;
